import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import moment from 'moment'
import iconDownload from 'images/icon-download.svg'

class ModalLog extends Component {
  render() {
    const { translate, closeModal, functionality, getTxt, log } = this.props
    const functionalityValue = functionality || (log && log.functionality)
    const functionalityKey = typeof functionalityValue === 'string' && functionalityValue
      ? (functionalityValue.startsWith('query.logs.') ? functionalityValue : `query.logs.${functionalityValue}`)
      : null
    const functionalityLabel = functionalityKey ? translate(functionalityKey) : '-'
    return (
      <Modal closeModal={closeModal}>
        <div className='modal-query-log'>
          <div>
            <strong>{translate('query.logs.modal.functionality')}</strong>
            <p>{functionalityLabel}</p>
          </div>

          <div className='modal-div-data'>
            <div className='modal-div-date'>
              <strong>{translate('query.logs.modal.date')}</strong>
              <p>{log.date && moment(log.date).format('l') || "-" }</p>
            </div>

            <div className='modal-div-hour'>
              <strong className='strong-label'>
                {translate('query.logs.modal.hour')}
              </strong>
              <p className='strong-label'>{log.date && moment(log.date).format('LT') || "-" }</p>
            </div>
          </div>

          <div className='modal-query-content'>
            <strong>{translate('queryLogs.table.column.endpoint')}</strong>
            <p>
              <div>{log.endpoint ? log.endpoint : '-'}</div>
            </p>
          </div>

          <div className='modal-query-content'>
            <strong>{translate('query.logs.modal.request')}</strong>
            <p>
              <div>{log.request ? log.request : '-'}</div>
            </p>
          </div>

          <div className='modal-query-content'>
            <strong>{translate('query.logs.modal.response')}</strong>
            <p>
              <div>{log.response ? log.response : '-'}</div>
            </p>
          </div>

          <div className='modal-query-btn-down'>
            <strong className='modal-query-btn-onClick' onClick={getTxt}>
              {translate('query.logs.modal.download')}
            </strong>
            <img
              onClick={getTxt}
              className='modal-query-btn-down-img modal-query-btn-onClick'
              src={iconDownload}
            />
          </div>

          <div style={{ marginLeft: '20%' }}>
            <button
              onClick={closeModal}
              style={{ width: '75%' }}
              className='button button-primary'
            >
              {translate('query.logs.modal.close')}
            </button>
          </div>
        </div>
      </Modal>
    )
  }
}

export default ModalLog

ModalLog.propTypes = {
  translate: PropTypes.func,
  closeModal: PropTypes.func,
  log: PropTypes.object,
  functionality: PropTypes.string,
  getTxt: PropTypes.func,
}
